import React, { createContext, useContext, useEffect, useState, useMemo } from "react";

const translations = {
  tr: {
    nav: {
      home: "Anasayfa",
      services: "Hizmetler",
      about: "Hakkımızda",
      team: "Ekip",
      events: "Etkinlikler",
      blog: "Blog",
      contact: "İletişim",
      cta: "Görüşme Planla",
    },
    common: {
      explore: "Keşfet",
      readMore: "Devamını oku",
      learnMore: "Daha fazla bilgi",
      getInTouch: "İletişime Geç",
      ourServices: "Hizmetlerimiz",
    },
    home: {
      eyebrow: "Zihinsel Sağlık & Kurumsal Refah",
      heroTitle: "Bağlılığı ve dayanıklılığı yüksek insan ortamları inşa edelim.",
      heroLead:
        "inTouch; iş ve örgüt psikolojisi temelli eğitim, atölye, danışmanlık ve bireysel terapi hizmetleriyle insanların ve kurumların yanında.",
      ctaPrimary: "Hizmetlerimizi Keşfedin",
      ctaSecondary: "Bize Ulaşın",
      stats: {
        programs: "Eğitim Programı",
        clients: "Kurumsal Müşteri",
        participants: "Eğitim Katılımcısı",
        years: "Yıllık Deneyim",
      },
      philosophyEyebrow: "Yaklaşımımız",
      philosophyTitle: "Bilim ile sıcaklığın buluştuğu bir alan.",
      philosophyBody:
        "İnsan iletişimini, çalışan refahını ve psikolojik güvenliği veriye dayalı yöntemlerle güçlendiriyoruz. Hem bireylere hem de kurumlara, gerçek hayatta işe yarayan, ölçülebilir destek sunuyoruz.",
      pillars: [
        { t: "In Touch with Self", d: "Biz; farkındalığı, öz düzenlemeyi ve iç dengeyi 'kişisel bir lüks' değil, sürdürülebilir çalışmanın temeli olarak görüyoruz." },
        { t: "In Touch with Others", d: "Biz; ekiplerin duyulduğu, fikirlerin bastırılmadığı, insanların sadece performanslarıyla değil varlıklarıyla da değer gördüğü alanlar yaratmaya inanıyoruz." },
        { t: "In Touch with Work", d: "Biz; anlamla bağ kuran, enerjiyi tüketmeyen, çalışanı güçlendiren bir çalışma kültürünün mümkün olduğuna inanıyoruz." },
        { t: "Dayanıklılık", d: "Kurumsal güçlenme ve bireysel iyilik hali." },
      ],
      whyEyebrow: "Neden inTouch?",
      whyTitle: "Fark yaratan altı yaklaşım",
      whyItems: [
        { t: "Bilimden besleniyoruz", d: "Yönetim, çalışma ve örgüt psikolojisinin bilimsel temellerine dayanıyoruz. Sezgiyle değil, kanıtla çalışıyoruz." },
        { t: "Deneyimsel öğrenme", d: "İnsan ancak yaşayarak değişir. Anlatmak yerine deneyimletiyoruz." },
        { t: "Her kurum biriciktir", d: "Raftan inen programlarımız yok. Önce kurumu anlıyor, sonra o kuruma özel tasarlıyoruz." },
        { t: "Bütünsel bakış", d: "Bireyi, ekibi ve kurumu birbirinden ayrı görmüyoruz. Birinde olan, kaçınılmaz olarak diğerini etkiler." },
        { t: "Performans ile psikoloji çatışmaz", d: "İnsanın iyiliği ile kurumun başarısı aynı yöne bakar. İkisi arasında seçim yapmanız gerekmiyor." },
        { t: "Akademiyi sahaya indiriyoruz", d: "Akademi ile iş dünyası arasındaki boşluğu kapatıyoruz. Kuram raflarda kalmasın, kalıcı bir değişime dönüşsün." },
      ],
      finalCtaTitle: "Size özel, psikoloji temelli çözümler için iletişime geçin.",
      finalCtaBody:
        "Kurumunuzun veya kendinizin ihtiyaçlarına uygun bir yolculuk için ilk adımı birlikte atalım.",
    },
    services: {
      eyebrow: "Hizmetlerimiz",
      title: "Kurumunuza ve size değer katan çözümler",
      lead:
        "İş ve örgüt psikolojisi alanındaki uzmanlığımızla, bireylerin ve kurumların potansiyelini ortaya çıkarıyoruz.",
      items: [
        {
          slug: "egitim",
          eyebrow: "01 — Eğitimler",
          t: "Eğitimler",
          d: "Bilimsel temelli, uygulamalı eğitim programlarıyla kurumların insan kaynağını güçlendiriyoruz.",
          long:
            "Liderlik, iletişim, çatışma yönetimi, tükenmişlik önleme ve psikolojik güvenlik gibi alanlarda kuruma özel modüler eğitim programları sunuyoruz. Her oturum, ölçümlenebilir öğrenme çıktılarıyla tasarlanır.",
          bullets: ["Liderlik & Yönetim", "Tükenmişlik & Stres", "Çatışma Yönetimi", "Psikolojik Güvenlik"],
        },
        {
          slug: "danismanlik",
          eyebrow: "02 — Danışmanlık",
          t: "Danışmanlık",
          d: "Kurumların psikolojik haritasını çıkarıyor, ihtiyaç analizleriyle sürdürülebilir çözümler üretiyoruz.",
          long:
            "Kurum kültürü değerlendirmesi, çalışan bağlılığı analizleri ve organizasyonel dönüşüm süreçlerinde stratejik ortağınız oluyoruz.",
          bullets: ["Kurum Kültürü", "Çalışan Deneyimi", "Liderlik Koçluğu", "Dönüşüm Yönetimi"],
        },
        {
          slug: "atolyeler",
          eyebrow: "03 — Atölyeler",
          t: "Atölyeler",
          d: "Sanat terapisi, yaratıcı drama ve interaktif yöntemlerle deneyimsel öğrenme ortamları kuruyoruz.",
          long:
            "Ekiplere özel atölye serileri; yaratıcı ifadeyi, empatiyi ve birlikte düşünmeyi teşvik ediyor. Hem yüz yüze hem hibrit formatta uygulanabiliyor.",
          bullets: ["Sanat Terapisi", "Yaratıcı Drama", "Mindfulness", "Takım Gelişimi"],
        },
        {
          slug: "olcme",
          eyebrow: "04 — Ölçme & Değerlendirme",
          t: "Ölçme & Değerlendirme",
          d: "Psikolojik haritalama ve psikometrik ölçümlerle kurumlara veriye dayalı raporlar sağlıyoruz.",
          long:
            "Bireysel ve kurumsal düzeyde geçerliliği kanıtlanmış araçlarla; bağlılık, kültür, refah ve liderlik kapasitesini ölçüyor; aksiyon önerileriyle raporluyoruz.",
          bullets: ["Bağlılık Anketleri", "Kültür Haritalaması", "Psikometrik Testler", "360° Geri Bildirim"],
        },
      ],
      process: {
        title: "Birlikte yürüdüğümüz yol",
        steps: [
          { t: "Dinleme", d: "İhtiyaçlarınızı ve hedeflerinizi anlamak için derinlemesine bir görüşme." },
          { t: "Tasarım", d: "Kuruma veya bireye özel yol haritası ve program tasarımı." },
          { t: "Uygulama", d: "Deneyimsel, etkileşimli ve ölçümlenebilir uygulama." },
          { t: "Etki Ölçümü", d: "Sonuçların raporlanması ve sürdürülebilirlik planı." },
        ],
      },
    },
    about: {
      eyebrow: "Hakkımızda",
      title: "Biz Kimiz?",
      lead:
        "inTouch, iş ve örgüt psikolojisinin bilimsel gücünü insanın sıcaklığıyla buluşturan bir eğitim ve danışmanlık merkezidir.",
      story:
        "Çalışma hayatının zorluklarını, stres faktörlerini ve değişen iş dinamiklerini biliyoruz. Bilgi aktarmakla yetinmiyor; insanların potansiyelini açığa çıkaran deneyimsel yöntemlerle kalıcı dönüşüm sağlıyoruz.",
      mission: {
        title: "Misyon",
        body:
          "İnsanların ve kurumların kendini güvende, görülmüş ve dayanıklı hissettiği iş ortamları inşa etmek.",
      },
      vision: {
        title: "Vizyon",
        body:
          "Psikoloji ve insan iyiliğini, modern çalışma kültürünün merkezine taşıyan öncü bir referans olmak.",
      },
    },
    team: {
      eyebrow: "Ekibimiz",
      title: "İnsanları, insanlar iyileştirir.",
      lead:
        "Klinik psikologlardan örgüt danışmanlarına; sahada deneyim kazanmış, yargılamayan, sıcak bir ekip.",
      members: [
        {
          name: "Dr. Selin Kayhan",
          role: "Kurucu, Endüstri & Örgüt Psikoloğu",
          bio: "15+ yıl boyunca uluslararası kurumlarda liderlik gelişimi ve kültür dönüşümü programları yürüttü.",
          img: "https://images.unsplash.com/photo-1484863137850-59afcfe05386?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2OTV8MHwxfHNlYXJjaHwxfHxzbWlsaW5nJTIwcHJvZmVzc2lvbmFsJTIwdGhlcmFwaXN0JTIwcG9ydHJhaXQlMjB3YXJtfGVufDB8fHx8MTc3ODg0MjgwNnww&ixlib=rb-4.1.0&q=85",
        },
        {
          name: "Mert Aydın",
          role: "Klinik Psikolog & Atölye Lideri",
          bio: "Sanat terapisi ve yaratıcı drama uzmanı. Bireysel terapi ve grup atölyeleri yürütüyor.",
          img: "https://images.unsplash.com/photo-1729250827839-9d969cfbcce0?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2OTV8MHwxfHNlYXJjaHwzfHxzbWlsaW5nJTIwcHJvZmVzc2lvbmFsJTIwdGhlcmFwaXN0JTIwcG9ydHJhaXQlMjB3YXJtfGVufDB8fHx8MTc3ODg0MjgwNnww&ixlib=rb-4.1.0&q=85",
        },
        {
          name: "Ayşe Demirtaş",
          role: "Örgüt Danışmanı, Ölçme & Değerlendirme",
          bio: "Psikometrik ölçüm araçları ve kültür haritalama projelerinde lider danışman.",
          img: "https://images.unsplash.com/photo-1599816434832-ac339dd3bc61?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2OTV8MHwxfHNlYXJjaHw0fHxzbWlsaW5nJTIwcHJvZmVzc2lvbmFsJTIwdGhlcmFwaXN0JTIwcG9ydHJhaXQlMjB3YXJtfGVufDB8fHx8MTc3ODg0MjgwNnww&ixlib=rb-4.1.0&q=85",
        },
      ],
      joinTitle: "Ekibimize katılmak ister misiniz?",
      joinBody:
        "İnsana, bilime ve dürüst iletişime inanan profesyonelleri kadromuzda görmek isteriz.",
    },
    blog: {
      eyebrow: "Blog & Kaynaklar",
      title: "Düşünceler, araştırmalar ve sahadan notlar",
      lead: "Çalışan refahı, kurumsal psikoloji ve kişisel iyilik hâli üzerine güncel yazılar.",
      readArticle: "Yazıyı oku",
      posts: [
        {
          slug: "psikolojik-guvenlik",
          category: "Kurum Kültürü",
          title: "Psikolojik güvenlik bir lüks değil, temel ihtiyaçtır",
          excerpt:
            "Çalışanların ‘konuşabilir miyim?’ sorusunu yanıtlayan kültürler, neden daha yenilikçi ve dayanıklı oluyor?",
          author: "Dr. Selin Kayhan",
          date: "12 Kasım 2025",
          img: "https://images.unsplash.com/photo-1542744173-8e7e53415bb0?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzl8MHwxfHNlYXJjaHwxfHxjb3Jwb3JhdGUlMjB3ZWxsbmVzcyUyMG9mZmljZSUyMHRlYW0lMjB3b3Jrc2hvcHxlbnwwfHx8fDE3Nzg4NDI4MDZ8MA&ixlib=rb-4.1.0&q=85",
          body: [
            "Psikolojik güvenlik, ekip üyelerinin küçük düşürülmeden hata yapabileceğine, fikir sunabileceğine inanmasıdır.",
            "Google’ın Aristoteles Projesi, en yüksek performanslı ekiplerin paylaştığı temel özelliğin psikolojik güvenlik olduğunu göstermiştir.",
            "Bunu inşa etmek için liderlerin önce kendi savunmacılıklarını fark etmesi gerekir. Yargılamadan sormak, kabul etmeden önce dinlemek.",
          ],
        },
        {
          slug: "tukenmislik",
          category: "Çalışan Refahı",
          title: "Tükenmişlik: Bireysel zayıflık değil, sistemsel bir uyarı",
          excerpt:
            "Tükenmişliği yalnızca dinlenmeyle değil; iş tasarımı, anlam ve sınırlarla aşıyoruz.",
          author: "Mert Aydın",
          date: "28 Ekim 2025",
          img: "https://images.unsplash.com/photo-1730342754575-0c8ca8e62c0b?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2MDV8MHwxfHNlYXJjaHwyfHxjYWxtJTIwdGhlcmFweSUyMHNlc3Npb24lMjBoYW5kcyUyMGludGVyaW9yfGVufDB8fHx8MTc3ODg0MjgwNnww&ixlib=rb-4.1.0&q=85",
          body: [
            "Dünya Sağlık Örgütü, tükenmişliği bir hastalık değil, bir işyeri olgusu olarak tanımlar.",
            "Kişisel düzeyde uyku, hareket ve sınır koymak işe yarar. Ancak kurumsal düzeyde iş yükü ve karar özerkliği ele alınmadan kalıcı çözüm yoktur.",
            "inTouch olarak, tükenmişliği önce bireyle, sonra ekiple, en sonunda sistemle çalışarak ele alıyoruz.",
          ],
        },
        {
          slug: "geri-bildirim",
          category: "Liderlik",
          title: "Geri bildirim: Hediyenin nazikçe sunulması",
          excerpt:
            "Sert eleştiri değil, dürüst ve şefkatli geri bildirim — büyümeyi mümkün kılan tek yol.",
          author: "Ayşe Demirtaş",
          date: "5 Ekim 2025",
          img: "https://images.unsplash.com/photo-1543248939-7b514293dc4c?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2MDV8MHwxfHNlYXJjaHwxfHxjYWxtJTIwdGhlcmFweSUyMHNlc3Npb24lMjBoYW5kcyUyMGludGVyaW9yfGVufDB8fHx8MTc3ODg0MjgwNnww&ixlib=rb-4.1.0&q=85",
          body: [
            "Geri bildirim verirken niyetimizi açıkça belirtmek, alıcının savunmaya geçme ihtimalini azaltır.",
            "‘Senin gelişimini önemsediğim için söylüyorum’ ifadesi, içeriği değil ilişkiyi konuşur.",
            "Etkili geri bildirim; gözlem + etki + öneri formülüyle, yargı değil bilgi taşır.",
          ],
        },
      ],
    },
    contact: {
      eyebrow: "İletişim",
      title: "İlk adımı birlikte atalım",
      lead:
        "Size özel bir görüşme planlamak veya hizmetlerimiz hakkında bilgi almak için aşağıdaki formu doldurabilirsiniz.",
      info: { addressTitle: "Adres", phoneTitle: "Telefon", emailTitle: "E-posta", hoursTitle: "Çalışma Saatleri", hoursBody: "Pazartesi – Cuma · 09:00 – 18:00" },
      form: {
        name: "Adınız Soyadınız",
        email: "E-posta",
        organization: "Kurum (opsiyonel)",
        subject: "Konu",
        message: "Mesajınız",
        submit: "Mesajı Gönder",
        sending: "Gönderiliyor…",
        success: "Mesajınız ulaştı. En kısa sürede dönüş yapacağız.",
        error: "Mesaj gönderilemedi. Lütfen tekrar deneyin.",
      },
    },
    footer: {
      tagline: "İnsana, bilime ve sanata dokunan deneyimler.",
      quickLinks: "Hızlı Bağlantılar",
      services: "Hizmetler",
      contact: "İletişim",
      copy: "© 2025 inTouch. Tüm hakları saklıdır.",
    },
    cookies: {
      text:
        "Daha iyi bir deneyim için çerez kullanıyoruz. Detaylı bilgi için Gizlilik & Çerez Politikamızı inceleyebilirsiniz.",
      accept: "Kabul Et",
      reject: "Sadece Gerekli Olanlar",
    },
  },

  en: {
    nav: {
      home: "Home",
      services: "Services",
      about: "About",
      team: "Team",
      events: "Events",
      blog: "Blog",
      contact: "Contact",
      cta: "Book a call",
    },
    common: {
      explore: "Explore",
      readMore: "Read more",
      learnMore: "Learn more",
      getInTouch: "Get in touch",
      ourServices: "Our Services",
    },
    home: {
      eyebrow: "Mental Health & Workplace Wellness",
      heroTitle: "Let’s build human spaces that are engaged, resilient — and kind.",
      heroLead:
        "inTouch offers training, workshops, consultancy and individual therapy grounded in industrial-organizational psychology — for people and the companies they shape.",
      ctaPrimary: "Explore our services",
      ctaSecondary: "Get in touch",
      stats: {
        programs: "Training Programs",
        clients: "Corporate Clients",
        participants: "Participants Trained",
        years: "Years of Experience",
      },
      philosophyEyebrow: "Our approach",
      philosophyTitle: "Where science meets warmth.",
      philosophyBody:
        "We strengthen human communication, employee wellbeing and psychological safety with evidence-based methods. We support both individuals and organisations with measurable, real-world tools.",
      pillars: [
        { t: "In Touch with Self", d: "We see awareness, self-regulation and inner balance not as personal luxuries, but as the foundation of sustainable work." },
        { t: "In Touch with Others", d: "We believe in creating spaces where teams feel heard, ideas are not suppressed, and people are valued not just for their performance but for their presence." },
        { t: "In Touch with Work", d: "We believe a work culture that connects with meaning, does not drain energy and empowers people is not only desirable -- it is possible." },
        { t: "Resilience", d: "From organisational strength to personal wellbeing." },
      ],
      whyEyebrow: "Why inTouch",
      whyTitle: "Six things that make us different",
      whyItems: [
        { t: "Rooted in science", d: "We draw from the scientific foundations of management, work and organisational psychology. We work with evidence, not intuition." },
        { t: "Experiential learning", d: "People only change through lived experience. We do not lecture -- we create the experience." },
        { t: "Every organisation is unique", d: "We do not have off-the-shelf programs. We first understand the organisation, then design specifically for it." },
        { t: "Holistic perspective", d: "We do not see the individual, the team and the organisation as separate. What happens in one inevitably affects the others." },
        { t: "Performance and psychology align", d: "Human wellbeing and organisational success point in the same direction. You do not have to choose between them." },
        { t: "Bringing academia to the field", d: "We close the gap between academia and the business world. Theory should not stay on shelves -- it should drive lasting change." },
      ],
      finalCtaTitle: "Tailored, psychology-led solutions — built around you.",
      finalCtaBody:
        "Take the first step toward a more engaged, resilient organisation — or a kinder relationship with yourself.",
    },
    services: {
      eyebrow: "Our Services",
      title: "Solutions that bring value to your team — and yourself",
      lead:
        "We unlock the potential of people and organisations with deep expertise in work and organisational psychology.",
      items: [
        {
          slug: "trainings",
          eyebrow: "01 — Trainings",
          t: "Trainings",
          d: "Science-based, hands-on programs that strengthen your human capital.",
          long:
            "Custom modular programs across leadership, communication, conflict, burnout prevention and psychological safety. Designed with measurable learning outcomes.",
          bullets: ["Leadership & Management", "Burnout & Stress", "Conflict Management", "Psychological Safety"],
        },
        {
          slug: "consultancy",
          eyebrow: "02 — Consultancy",
          t: "Consultancy",
          d: "We map your organisation’s psychological landscape and build sustainable solutions.",
          long:
            "From culture diagnostics and engagement analytics to leadership coaching and transformation support — we partner with you strategically.",
          bullets: ["Culture", "Employee Experience", "Leadership Coaching", "Change Management"],
        },
        {
          slug: "workshops",
          eyebrow: "03 — Workshops",
          t: "Workshops",
          d: "Experiential learning through art therapy, creative drama and interactive methods.",
          long:
            "Team workshop series that unlock creative expression, empathy and collective thinking — delivered in-person or hybrid.",
          bullets: ["Art Therapy", "Creative Drama", "Mindfulness", "Team Development"],
        },
        {
          slug: "assessment",
          eyebrow: "04 — Assessment",
          t: "Assessment",
          d: "Psychometric and culture-mapping tools that turn feelings into data.",
          long:
            "Validated instruments measuring engagement, culture, wellbeing and leadership capacity — paired with concrete action recommendations.",
          bullets: ["Engagement Surveys", "Culture Mapping", "Psychometrics", "360° Feedback"],
        },
      ],
      process: {
        title: "How we work together",
        steps: [
          { t: "Listen", d: "A deep conversation to understand your goals and context." },
          { t: "Design", d: "A roadmap and program tailored to you or your team." },
          { t: "Deliver", d: "Experiential, interactive and measurable delivery." },
          { t: "Measure", d: "Results reporting and a sustainability plan." },
        ],
      },
    },
    about: {
      eyebrow: "About",
      title: "Who we are",
      lead:
        "inTouch is a training and consultancy studio bringing the scientific power of organisational psychology together with human warmth.",
      story:
        "We understand the challenges of modern work — its stressors, ambiguity and changing dynamics. We don’t just transfer knowledge: we create lasting change through experiential methods.",
      mission: {
        title: "Mission",
        body: "To build work environments where people and organisations feel safe, seen and resilient.",
      },
      vision: {
        title: "Vision",
        body:
          "To become a leading reference that places psychology and human wellbeing at the centre of modern work.",
      },
    },
    team: {
      eyebrow: "Our team",
      title: "People are healed by people.",
      lead:
        "Clinical psychologists, organisational consultants, and field practitioners — non-judgmental, warm and experienced.",
      members: [
        {
          name: "Dr. Selin Kayhan",
          role: "Founder · IO Psychologist",
          bio: "15+ years leading leadership and culture-transformation programs in international companies.",
          img: "https://images.unsplash.com/photo-1484863137850-59afcfe05386?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2OTV8MHwxfHNlYXJjaHwxfHxzbWlsaW5nJTIwcHJvZmVzc2lvbmFsJTIwdGhlcmFwaXN0JTIwcG9ydHJhaXQlMjB3YXJtfGVufDB8fHx8MTc3ODg0MjgwNnww&ixlib=rb-4.1.0&q=85",
        },
        {
          name: "Mert Aydın",
          role: "Clinical Psychologist · Workshop Lead",
          bio: "Specialist in art therapy and creative drama. Leads individual therapy and group workshops.",
          img: "https://images.unsplash.com/photo-1729250827839-9d969cfbcce0?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2OTV8MHwxfHNlYXJjaHwzfHxzbWlsaW5nJTIwcHJvZmVzc2lvbmFsJTIwdGhlcmFwaXN0JTIwcG9ydHJhaXQlMjB3YXJtfGVufDB8fHx8MTc3ODg0MjgwNnww&ixlib=rb-4.1.0&q=85",
        },
        {
          name: "Ayşe Demirtaş",
          role: "Org. Consultant · Assessment Lead",
          bio: "Lead consultant on psychometric measurement and culture-mapping projects.",
          img: "https://images.unsplash.com/photo-1599816434832-ac339dd3bc61?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2OTV8MHwxfHNlYXJjaHw0fHxzbWlsaW5nJTIwcHJvZmVzc2lvbmFsJTIwdGhlcmFwaXN0JTIwcG9ydHJhaXQlMjB3YXJtfGVufDB8fHx8MTc3ODg0MjgwNnww&ixlib=rb-4.1.0&q=85",
        },
      ],
      joinTitle: "Want to join our team?",
      joinBody:
        "We’d love to meet professionals who believe in people, science and honest conversation.",
    },
    blog: {
      eyebrow: "Blog & Resources",
      title: "Thoughts, research and notes from the field",
      lead:
        "Articles on workplace wellbeing, organisational psychology and personal flourishing.",
      readArticle: "Read article",
      posts: [
        {
          slug: "psychological-safety",
          category: "Culture",
          title: "Psychological safety is not a luxury — it’s the foundation",
          excerpt:
            "Cultures that can answer ‘can I speak up?’ outperform on innovation and resilience.",
          author: "Dr. Selin Kayhan",
          date: "Nov 12, 2025",
          img: "https://images.unsplash.com/photo-1542744173-8e7e53415bb0?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzl8MHwxfHNlYXJjaHwxfHxjb3Jwb3JhdGUlMjB3ZWxsbmVzcyUyMG9mZmljZSUyMHRlYW0lMjB3b3Jrc2hvcHxlbnwwfHx8fDE3Nzg4NDI4MDZ8MA&ixlib=rb-4.1.0&q=85",
          body: [
            "Psychological safety is the belief that one can take an interpersonal risk without being humiliated.",
            "Google’s Project Aristotle showed that high-performing teams shared this single trait above all.",
            "Building it starts with leaders noticing their own defensiveness — asking before judging.",
          ],
        },
        {
          slug: "burnout",
          category: "Wellbeing",
          title: "Burnout: A systemic warning, not personal weakness",
          excerpt:
            "Burnout responds not only to rest, but to job design, meaning and boundaries.",
          author: "Mert Aydın",
          date: "Oct 28, 2025",
          img: "https://images.unsplash.com/photo-1730342754575-0c8ca8e62c0b?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2MDV8MHwxfHNlYXJjaHwyfHxjYWxtJTIwdGhlcmFweSUyMHNlc3Npb24lMjBoYW5kcyUyMGludGVyaW9yfGVufDB8fHx8MTc3ODg0MjgwNnww&ixlib=rb-4.1.0&q=85",
          body: [
            "The WHO defines burnout as an occupational phenomenon — not a disease.",
            "Personal sleep, movement and boundaries help. But without workload and autonomy redesign, there is no lasting fix.",
            "At inTouch, we address burnout at three levels: individual, team and system.",
          ],
        },
        {
          slug: "feedback",
          category: "Leadership",
          title: "Feedback is a gift — when offered gently",
          excerpt:
            "Not sharp critique, but honest and compassionate feedback is what makes growth possible.",
          author: "Ayşe Demirtaş",
          date: "Oct 5, 2025",
          img: "https://images.unsplash.com/photo-1543248939-7b514293dc4c?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2MDV8MHwxfHNlYXJjaHwxfHxjYWxtJTIwdGhlcmFweSUyMHNlc3Npb24lMjBoYW5kcyUyMGludGVyaW9yfGVufDB8fHx8MTc3ODg0MjgwNnww&ixlib=rb-4.1.0&q=85",
          body: [
            "Stating intent before content drops the receiver’s defensiveness.",
            "‘I’m saying this because I care about your growth’ — relationship before content.",
            "Effective feedback follows: observation + impact + suggestion. Information, not judgment.",
          ],
        },
      ],
    },
    contact: {
      eyebrow: "Contact",
      title: "Let’s take the first step together",
      lead:
        "Use the form below to book a tailored consultation or learn more about our services.",
      info: { addressTitle: "Address", phoneTitle: "Phone", emailTitle: "Email", hoursTitle: "Hours", hoursBody: "Mon – Fri · 09:00 – 18:00" },
      form: {
        name: "Full name",
        email: "Email",
        organization: "Organisation (optional)",
        subject: "Subject",
        message: "Your message",
        submit: "Send message",
        sending: "Sending…",
        success: "Thank you — your message has reached us. We’ll be in touch soon.",
        error: "Couldn’t send the message. Please try again.",
      },
    },
    footer: {
      tagline: "Experiences that touch the human, the scientific and the artistic.",
      quickLinks: "Quick links",
      services: "Services",
      contact: "Contact",
      copy: "© 2025 inTouch. All rights reserved.",
    },
    cookies: {
      text:
        "We use cookies for a better experience. See our Privacy & Cookies Policy for details.",
      accept: "Accept",
      reject: "Necessary only",
    },
  },
};

const LanguageContext = createContext({ lang: "tr", setLang: () => {}, t: translations.tr });

export function LanguageProvider({ children }) {
  const [lang, setLang] = useState(() => {
    if (typeof window === "undefined") return "tr";
    return localStorage.getItem("intouch.lang") || "tr";
  });

  useEffect(() => {
    if (typeof window !== "undefined") {
      localStorage.setItem("intouch.lang", lang);
      document.documentElement.lang = lang;
    }
  }, [lang]);

  const value = useMemo(
    () => ({
      lang,
      setLang,
      toggle: () => setLang((p) => (p === "tr" ? "en" : "tr")),
      t: translations[lang],
    }),
    [lang]
  );

  return <LanguageContext.Provider value={value}>{children}</LanguageContext.Provider>;
}

export function useLang() {
  return useContext(LanguageContext);
}
